import { Extension } from "@tiptap/core";

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		textColor: {
			setTextColor: (color: string) => ReturnType;
			unsetTextColor: () => ReturnType;
		};
	}
}

export const TextColor = Extension.create({
	name: "textColor",

	addOptions() {
		return {
			types: ["textStyle", "heading", "paragraph"],
		};
	},

	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					color: {
						default: null,
						parseHTML: (element) => element.style.color || null,
						renderHTML: (attributes) => {
							if (!attributes.color) return {};
							return { style: `color: ${attributes.color}` };
						},
					},
				},
			},
		];
	},

	addCommands() {
		return {
			setTextColor:
				(color: string) =>
				({ chain }) => {
					return chain().setMark("textStyle", { color }).run();
				},
			unsetTextColor:
				() =>
				({ chain }) => {
					return chain().setMark("textStyle", { color: null }).removeEmptyTextStyle().run();
				},
		};
	},
});
